import './en';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
